(() => {
  const init = (root) => {
    const track = root.querySelector('[data-ar-reviews-track]');
    // querySelectorAll → bindet sowohl Desktop-Header-Pfeile als auch
    // Mobile-Below-Pfeile (2 Pärchen prev/next).
    const prevBtns = root.querySelectorAll('[data-ar-reviews-prev]');
    const nextBtns = root.querySelectorAll('[data-ar-reviews-next]');
    if (!track || prevBtns.length === 0 || nextBtns.length === 0) return;

    const getStep = () => {
      const card = track.querySelector('.ar-review-card');
      if (!card) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      const atStart = track.scrollLeft <= 0;
      const atEnd = track.scrollLeft >= max;
      prevBtns.forEach((b) => { b.disabled = atStart; });
      nextBtns.forEach((b) => { b.disabled = atEnd; });
    };

    prevBtns.forEach((b) => {
      b.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    });
    nextBtns.forEach((b) => {
      b.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    updateButtons();
  };

  const boot = () => {
    document.querySelectorAll('[data-ar-reviews]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector('[data-ar-reviews]')) {
      e.target.querySelectorAll('[data-ar-reviews]').forEach(init);
    } else if (e.target && e.target.matches('[data-ar-reviews]')) {
      init(e.target);
    }
  });
})();
